{
    "webshop_offer_voucher_correctCode": "Girilen kod doğru",
    "webShop_howToFindId_desc": "Oyuncu profilindeki kişisel kimliğini bulabilir ve kopyalayabilirsin.",
    "webShop_howToFindId_link": "Kişisel kimliğimi nerede bulabilirim?",
    "webshop_offer_voucher_codeIsIncorrect": "Kod yanlış",
    "webshop_offer_voucher_enterYourCode": "Kişisel Kimliğini gir",
    "webShop_unexpectedError_desc": "Beklenmedik bir hata gerçekleşti, lütfen daha sonra tekrar dene.",
    "webShop_accountBanned_desc": "Hesap engellendi!",
    "webshop_confirm": "OK",
    "webshop_termsConditions_1": "Şart ve Koşullar",
    "webshop_purchase_privacyPolicy": "Gizlilik Politikası",
    "webshop_legal_1": "Yasal",
    "webshop_support_1": "Destek",
    "mbs_access_welcome_desc": "Hoş geldin {0}",
    "btn_login": "Oturum aç",
    "mbs_access_error_sessionExpired_desc": "Oturumunun süresi doldu. Lütfen hesap kimliğini manuel olarak gir."
}
